import { useFormikContext } from 'formik'
import { filter } from 'lodash'
import { useEffect, useState } from 'react'
import { RecoveryCertificateQuery_recoveryCertificates } from './__generated__/RecoveryCertificateQuery'

export const CertificateFiles = ({
  recoveryCertificate,
  edit,
}: {
  recoveryCertificate: RecoveryCertificateQuery_recoveryCertificates
  edit: boolean
}) => {
  const [fileUrls, setFileUrls] = useState<RecoveryCertificateQuery_recoveryCertificates['fileUrls']>(
    recoveryCertificate?.fileUrls || []
  )

  useEffect(() => {
    if (Array.isArray(recoveryCertificate?.fileUrls)) {
      setFileUrls(recoveryCertificate?.fileUrls)
    }
  }, [recoveryCertificate])

  const { setFieldValue } = useFormikContext()

  const deleteFile = (fileUrl) => {
    const remainingFileUrls = filter(fileUrls, (file) => file !== fileUrl)
    setFieldValue('fileUrls', remainingFileUrls)
    setFileUrls(remainingFileUrls)
  }

  return (
    <article className="message">
      <div className="message-header">
        <p className="has-text-light">Files</p>
      </div>
      <div className="message-body p-0">
        <p className="is-size-7 has-background-warning-light p-3">(Files are Automatically Deleted after 30 days)</p>

        <table className="table is-fullwidth is-striped is-size-7 has-valign-middle m-0">
          <tbody>
            {fileUrls.map((fileUrl, key) => (
              <tr key={key}>
                <td>
                  <a href={fileUrl} target="_blank" rel="noreferrer">
                    {fileUrl.split('/').pop()}
                  </a>
                </td>
                {edit && (
                  <td>
                    <button className="button is-danger" onClick={() => deleteFile(fileUrl)}>
                      Delete
                    </button>
                  </td>
                )}
              </tr>
            ))}
            <tr>
              <td>
                <p>Upload New Files</p>
              </td>
              <td>
                <input
                  type="file"
                  multiple
                  accept="image/*, .pdf, .heic"
                  name="fileUploads"
                  onChange={(event) => {
                    setFieldValue('fileUploads', event.currentTarget.files)
                  }}
                />
              </td>
            </tr>
          </tbody>
        </table>
        <p className="is-size-7 has-background-info-light p-3">(Hint: hold CTRL to select multiple files to upload)</p>
      </div>
    </article>
  )
}

export default CertificateFiles
